import { HttpError, PointsSummary } from '@rd/types';
import {
  PointsSummaryActions,
  PointsSummaryActionTypes,
} from '../actions/points-summary.actions';

export interface PointsSummaryState {
  pointsSummary: PointsSummary | null;
  error: HttpError | null;
  loading: boolean;
}

const initialState: PointsSummaryState = {
  pointsSummary: {
    pointsBalance: 0,
    accruals: [],
    tranches: [],
  },
  error: null,
  loading: false,
};

export function pointsSummaryReducer(
  state: PointsSummaryState = initialState,
  action: PointsSummaryActions,
): PointsSummaryState {
  switch (action.type) {
    case PointsSummaryActionTypes.LOAD_POINTS_SUMMARY:
      return {
        ...state,
        loading: true,
      };

    case PointsSummaryActionTypes.LOAD_POINTS_SUMMARY_SUCCESS:
      return {
        ...state,
        pointsSummary: action.payload,
        error: null,
        loading: false,
      };

    case PointsSummaryActionTypes.LOAD_POINTS_SUMMARY_FAIL:
      return {
        ...state,
        pointsSummary: null,
        error: action.payload,
        loading: false,
      };
  }

  return state;
}
